import React from 'react'
import { connect } from 'react-redux'
import { styled } from '@mui/material/styles'
import { Box, Typography } from '@mui/material'
import { Schedule } from '@mui/icons-material'
import classNames from 'classnames'
import { minSecTime } from '../../lib/util'
import './Timer.scss'

const TimerBox = styled(Box)(
  ({ theme }) => `
  .timer-remaining {
    color: ${theme.palette.text.primary};

    &.running {
      color: ${theme.palette.action.timerRunning};
    }
  }
`
)

const Timer = ({ className, timer, rule }) => {
  return rule.other.timer.active && (
    <TimerBox className={classNames(className, 'timer')}>
      <Schedule />
      <Typography variant="h6"
                  className={classNames('timer-remaining', { running: timer.running })}>
        {minSecTime(timer.remaining)}
      </Typography>
    </TimerBox>
  )
}

export default connect(
  state => ({
    timer: state.timer,
    rule: state.rule
  })
)(Timer)
